import React from 'react'
import { CircularProgress, Grid } from '@material-ui/core'

const csvSpinner = () => {
  return (
    <Grid item xs={12} style={{ textAlign: 'center' }}>
      <p>Your csv is being created...</p>
      <CircularProgress />
    </Grid>
  )
}

export default csvSpinner
